import "whatwg-fetch";

import Action from "../action/Action.ts";

const BookAction = {
    getUnPaidList(token: string, callback: (data: unknown) => void, errorHandler: (error: unknown) => void) {
        const path = "/admin/books/unpaid";
        const header = new Headers();
        const body = null;
        Action.fetchAuthorizedJson(path, token, "GET", header, body, callback, errorHandler);
    },
    getPaidAndDeletedList(token: string, callback: (data: unknown) => void, errorHandler: (error: unknown) => void) {
        const path = "/admin/books/deleted/paid";
        const header = new Headers();
        const body = null;
        Action.fetchAuthorizedJson(path, token, "GET", header, body, callback, errorHandler);
    },
    getNoPlanList(token: string, callback: (data: unknown) => void, errorHandler: (error: unknown) => void) {
        const path = "/admin/books/noplan";
        const header = new Headers();
        const body = null;
        Action.fetchAuthorizedJson(path, token, "GET", header, body, callback, errorHandler);
    },
};

export default BookAction;
